// Production environment configuration

const environment = {
  production: true,
  backendUrl: 'https://flamenavigator.tizbi.com/',
  sellneticsUrl: 'http://sellnetics.com/sellnetics-av18/login-request',
  appVersion: require('../../package.json').version,
  environment: 'production'
}

export default environment

